import fr from 'facet-rest';

export const PlaidLinkSessionTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  });

export const PlaidLinkSessionEditOverride = fr.metaOverride();
